import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getListFromValues, hasChangedValues, getFormValue, getMergedValues, nullDate, changeItemsValue } from '../../public/utility'


class SupplierChangeApplyDetail extends React.Component {
	state = {
		readOnly: this.props.readOnly || false,
	}

	componentDidMount = () => {
		this.doGetSupplierChangeApply(this.props.id, '')
	}

	doGetSupplierChangeApply = (id, fieldsets) => {
		const { taskName } = this.props
		Tyan.doPostEvent({
			event: 'GetSupplierChangeApply',
			data: { id, taskName },
			onEnd: ({ errorMessage, bReadOnly, initValues基本信息, initValues更改前供应商, initValues更改后供应商, optionsParas }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				this.setState({
					...{ id, optionsParas, bReadOnly, initValues更改前供应商, initValues更改后供应商, },
					...(fieldsets ? {} : { initValues基本信息, changedValues基本信息: {}, changedValues更改后供应商: {}, changedValues更改前供应商: {} })
				})
			}
		})
	}

	handlerSave = () => {
		const { id, changedValues基本信息, } = this.state
		Tyan.doPostEvent({
			event: 'SaveSupplierChangeApply',
			data: { id, changedValues基本信息, changedValues更改后供应商: getMergedValues(this, '更改后供应商'), changedValues更改前供应商: getMergedValues(this, '更改前供应商') },
			onEnd: ({ errorMessage, id }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
					return
				}
				Ext.toast('保存成功')
				this.doGetSupplierChangeApply(id, '')
			}
		})
	}

	handlerDelete = () => {
		const { onClose, onSave } = this.props
		const { id } = this.state
		Tyan.pubForm.showConfirm('确定要删除？', () =>
			Tyan.doPostEvent({
				event: 'DeleteSupplierChangeApply',
				data: { id },
				onEnd: ({ errorMessage }) => {
					if (errorMessage) {
						Tyan.pubForm.showError(errorMessage)
						return
					}
					Ext.toast('删除成功')
					onClose && onClose()
					onSave && onSave()
				}
			}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		if (!this.bChanged()) {
			onClose && onClose()
			return
		}
		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	bChanged = () => {
		return hasChangedValues(this)
	}
	handleSupplierContactChange = (v) => {
		const 供应商名称 = getFormValue(this, '基本信息', '供应商名称')
		Tyan.doPostEvent({
			event: 'GetSupplierContactInfo',
			data: { contactName: v, supplierName: 供应商名称 },
			onEnd: ({ errorMessage, ContactInfo }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					changeItemsValue(this, '更改前供应商', ['联系人', '联系电话', '邮箱'], [ContactInfo.ContactName, ContactInfo.Phone, ContactInfo.Email])
					changeItemsValue(this, '更改后供应商', ['联系人', '联系电话', '邮箱'], [ContactInfo.ContactName, ContactInfo.Phone, ContactInfo.Email])
				}
			}
		})
	}
	fieldset供应商信息 = () => {
		const { bReadOnly, readOnly } = this.state
		return [
			{ _text: '申请单号', minWidth: '45%', disabled: true },
			{ _text: '申请人', minWidth: '45%', disabled: true },
			{ _date: '申请时间', minWidth: '45%', disabled: true },
			{ _text: '申请部门', minWidth: '45%', disabled: true },
			{ _text: '供应商名称', minWidth: '45%', disabled: true },
			{ _text: '备注', minWidth: '95%', maxRows: 3 },
			{ _files: '附件', minWidth: '95%', },
			{
				_border: '更改前', minWidth: '45%', disabled: true, fieldset: '更改前供应商', items: [
					{ _checkbox: '公司资质', minWidth: '95%' },
					{ _text: '银行开户名称', minWidth: '95%' },
					{ _text: '开户银行', minWidth: '95%' },
					{ _text: '银行地址', minWidth: '95%' },
					{ _text: '公司地址', minWidth: '95%' },
					{ _select: '联系人', minWidth: '95%', disabled: bReadOnly || readOnly, onChange: (v) => this.handleSupplierContactChange(v), },
					{ _text: '联系电话', minWidth: '95%', },
					{ _text: '邮箱', minWidth: '95%', },
					{ _select: '发票种类', minWidth: '95%' },
					{ _select: '税分类', minWidth: '95%' },
					{ _select: '付费条件', name: '付款方式', minWidth: '95%' },
					{ _text: '银行帐号', minWidth: '95%' },
					{ _select: '交易币别', minWidth: '95%' },
					{ _text: 'Switf code', name: 'SwitfCode', minWidth: '95%' },
					{ _select: '发票税率', minWidth: '95%' },
				]
			},
			{
				_border: '更改后', minWidth: '45%', fieldset: '更改后供应商', items: [
					{ _checkbox: '公司资质', minWidth: '95%' },
					{ _text: '银行开户名称', minWidth: '95%' },
					{ _text: '开户银行', minWidth: '95%' },
					{ _text: '银行地址', minWidth: '95%' },
					{ _text: '公司地址', minWidth: '95%' },
					{ _text: '联系人', minWidth: '95%' },
					{ _text: '联系电话', minWidth: '95%' },
					{ _text: '邮箱', minWidth: '95%' },
					{ _select: '发票种类', minWidth: '95%' },
					{ _select: '税分类', minWidth: '95%' },
					{ _select: '付费条件', name: '付款方式', minWidth: '95%' },
					{ _text: '银行帐号', minWidth: '95%' },
					{ _select: '交易币别', minWidth: '95%' },
					{ _text: 'Switf code', name: 'SwitfCode', minWidth: '95%' },
					{ _select: '发票税率', minWidth: '95%' },
				]
			},
		]
	}

	fieldset流转日志 = () => {
		return [
			{ _html: '', name: '流转日志', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	fieldset签核流程 = () => {
		return [
			{ _html: '', name: '签核流程', minWidth: '95%', style: { textAlign: 'left' } }]
	}

	render() {
		const { showMessage: Message, showBody: Body, readOnly, search } = this.props
		const { errorMessage, initValues基本信息, id, bReadOnly, } = this.state
		if (!initValues基本信息) return <Message text={'请稍等 ...'} />
		if (errorMessage) return <Message text={errorMessage} />
		const bChanged = this.bChanged()
		return <Body data={this} maxWidth="1100"
			controls={
				(bReadOnly || readOnly) ?
					[
						{ _flow: 'SupplierChangeApplyFlow', disabled: this.bChanged(), cdt: () => id > 0 && !search, },
						{ _button: bChanged && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
					] : [
						{ _flow: 'SupplierChangeApplyFlow', disabled: this.bChanged(), cdt: () => id > 0 && !search, },
						{ _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !bChanged },
						{ _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
						{ _button: bChanged ? '取消' : '关闭', icon: 'close', handler: this.handlerClose },
					]}
			fieldsets={
				[
					id > 0 && {
						_fieldsets: [
							{ title: '签核流程', name: '基本信息', _fieldset: this.fieldset签核流程(), fullblock: true },
							{ title: '流转日志', name: '基本信息', _fieldset: this.fieldset流转日志(), fullblock: true },
						], height: '40%', docked: 'bottom', margin: '0 5 0 5',
					},
					{ title: '基本信息', name: '基本信息', _fieldset: this.fieldset供应商信息(), disabled: bReadOnly || readOnly },
				]}
		/>
	}
}

export default connect()(SupplierChangeApplyDetail)